<script>
import { Validator } from "@/plugins/validator";
import { treatmentMetaFields as metaFields } from "./metaFields";
import Vue from 'vue';
import { RichTextEditorPlugin, Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar, Table } from "@syncfusion/ej2-vue-richtexteditor";
Vue.use(RichTextEditorPlugin);

export default {
    name: "DischargeTreatment",

    data() {

        return {
            prescription: {
                id: 0,
                encounterID: 0,
                date: window.moment().format(`YYYY-MM-DD`),
                itemID: 0,
                itemName: ``,
                prescriptionDosageRouteDuration: ``,
                charges: 0,
                userName: this.$root.username,
                isDischarge: true,
                from: 'inpatients',
            },
            noneDrugTreatment: {
                encounterID: 0,
                trxDate: window.moment().format('YYYY-MM-DD'),
                description: ``,
                userName: this.$root.username,
                cancelled: false,
            },
            items: [],
            errors: [],
            showItems: false,
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 
                border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    props: {

        patient: Object,
        showModal: Boolean,
        clinicians: Array,
        prescriptions: Array,
        ndtreatments: Array,
    },

    methods: {

        searchDrug() {

            if(!this.prescription.itemName) return;

            this.$root.loading=true;
            let url = `MedicalFile/GetDrugsandConsumbles`;
                url += `?TypeId=0&SearchText=${this.prescription.itemName}`;

            this.$http.get(url).then(({data}) => {
                this.items = data;
                this.$root.loading = false;
                this.showItems = true;
            }).catch(() => { this.$root.loading=false; });
        },

        parseItem(item) {

            this.prescription = {
                ...this.prescription,
                ...item,
                charges: item.cashPrice,
            };
            this.showItems = false;
        },

        saveData() {
            const prescription = {
                ...this.prescription,
                patientID: this.patient.patienT_ID,
                visitNo: this.patient.visitNo,
            };
            new Validator(prescription, metaFields).validate().then(() => {
                this.$root.loading = true;
                this.errors = [];
                this.$http.post(`MedicalFile/PatientDrugsandConsumablesTreatment`, prescription)
                    .then(() => {
                        this.$emit(`refresh`);
                        this.prescription = {
                            id: 0,
                            encounterID: 0,
                            patientID: this.patient.patienT_ID,
                            visitNo: this.patient.visitNo,
                            requestedBy: ``,
                            routeId: 0,
                            userName: this.$root.username,
                            itemName: ``,
                            charges: 0,
                            isDischarge: true,
                        };
                        this.$root.loading = false;
                }).catch(() => { this.$root.loading = false; });
            }).catch(errors => { this.errors = errors; });
        },

        saveNoneDrugTreatment() {
            if(!this.noneDrugTreatment.description) return;

            this.$root.loading = true;
            const noneDrugTreatment = {
                ...this.noneDrugTreatment,
                patientID: this.patient.patienT_ID,
                visitNo: this.patient.visitNo,
            };
            this.$http.post(`MedicalFile/PatientNoneDrugTreatment`, noneDrugTreatment)
                .then(() => { 
                    this.noneDrugTreatment = {
                        encounterID: 0,
                        trxDate: window.moment().format('YYYY-MM-DD'),
                        description: ``,
                        userName: this.$root.username,
                        cancelled: false,
                    };
                    this.$emit(`refresh`);
                    this.$root.loading = false;
                }).catch(() => { 
                    this.$root.loading = false; 
                });
        },
    },

    provide: {

         richtexteditor:[Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar, Table]
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-2/3 w-10/12">
  <template v-slot:title>
    <h5>Discharge Medication</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center">
        <ul class="w-full flex border-b-2 border-gray-500">
            <li class="-mb-px mr-1">
                <a href="javascript:void(0)" @click.prevent="active=0" 
                  class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold 
                      whitespace-no-wrap" 
                  :class="active == 0 ? activeClass : inActiveClass">Prescription</a>
            </li>
            <li class="-mb-px mr-1">
                <a href="javascript:void(0)" @click.prevent="active=1"
                  class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold
                       whitespace-no-wrap"
                  :class="active == 1 ? activeClass : inActiveClass">None Drug Treatment</a>
            </li>
        </ul>
        <div class="w-full flex flex-wrap" v-show="active == 0">
            <div class="md:w-1/5 sm:w-full p-tiny">
                <label for="grid-drug" class="label-control">Drug:</label>
                <input type="text" 
                    v-model.trim="prescription.itemName" @keydown.enter="searchDrug" 
                    id="grid-drug" class="input-control input-sm text-xs" 
                    placeholder="Search drug">
                <p class="form-text-error" 
                    v-if="errors.filter(error => error.field == 'itemName').length">
                    {{ errors.filter(error => error.field == 'itemName')[0].message }}</p>
                <p class="form-text-error" 
                    v-if="errors.filter(error => error.field == 'itemID').length">
                    {{ errors.filter(error => error.field == 'itemID')[0].message }}</p>
            </div>
            <tail-drug-select 
                :items="items"
                :showModal="showItems"
                @itemSelected="parseItem" 
                @closeModal="showItems=false" 
            />
            <div class="md:w-1/4 sm:w-full p-tiny">
                <label for="grid-description" class="label-control">Prescription:</label>
                <textarea id="grid-description" 
                    v-model.trim="prescription.prescriptionDosageRouteDuration" 
                    cols="30" rows="1" class="input-sm input-control text-xs"></textarea>
                <p class="form-text-error" 
                    v-if="errors.filter(error => error.field == 'prescriptionDosageRouteDuration').length">
                    {{ errors.filter(error => error.field == 'prescriptionDosageRouteDuration')[0].message }}</p>
            </div>
            <div class="w-1/2 md:w-1/4 p-tiny">
              <label for="grid-clinician" class="label-control">Clinician:</label>
              <v-select 
                v-model.trim="prescription.requestedBy"
                :options="clinicians" label="names"
                :reduce="clinician => clinician.names"
                id="grid-clinician" class="bg-white text-xs">
              </v-select>
              <p class="form-text-error" 
                    v-if="errors.filter(error => error.field == 'clinician').length">
                      {{ errors.filter(error => error.field == 'clinician')[0].message }}</p>
            </div>
            <div class="md:w-1/5 sm:w-full p-tiny mt-4">
                <button 
                    class="btn-sm btn-primary text-xs rounded" 
                    @click.prevent="saveData">
                        <i class="fa fa-save"></i> Prescription</button>
            </div>
            <div class="w-full flex flex-row">
                <div class="flex-1">
                    <label for="grid-min-price" class="font-medium text-sm">
                        <input v-model="prescription.charges" 
                            :value="prescription.minimumPrice"
                            type="radio" id="grid-min-price">
                            Min Price ({{ prescription.minimumPrice | numberFormat }})</label>
                </div>
                <div class="flex-1">
                    <label for="grid-cash-price" class="font-medium text-sm">
                        <input v-model="prescription.charges" 
                            :value="prescription.cashPrice"
                            type="radio" id="grid-cash-price">
                            Cash Price ({{ prescription.cashPrice | numberFormat }})</label>
                </div>
                <div class="flex-1">
                    <label for="grid-max-price" class="font-medium text-sm">
                        <input v-model="prescription.charges" 
                            :value="prescription.maximunPrice"
                            type="radio" id="grid-max-price">
                            Max Price ({{ prescription.maximunPrice | numberFormat }})</label>
                </div>
            </div>
            <div class="w-full overflow-auto my-2">
                <table class="table">
                    <thead class="bg-blue-500 text-white text-sm">
                        <tr>
                            <th class="p-tiny">Id</th>
                            <th class="p-tiny">Item</th>
                            <th class="p-tiny">Prescription</th>
                            <th class="p-tiny">Requested By</th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100 text-xs">
                        <tr v-for="presc in prescriptions" :key="presc.code">
                            <td class="p-tiny">{{ presc.code }}</td>
                            <td class="p-tiny">{{ presc.drug }}</td>
                            <td class="p-tiny">{{ presc.description || `-` }}</td>
                            <td class="p-tiny">{{ presc.requested_By }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="w-full flex flex-wrap" v-show="active == 1">
            <div class="w-full p-tiny">
                <label for="" class="label-control">Notes:</label>
                <ejs-richtexteditor ref="none-drug-treatment-rte" v-model="noneDrugTreatment.description" 
                    :height="230" :toolbarSettings="{
                      items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
                      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
                      'LowerCase', 'UpperCase', 'SuperScript', 'SubScript' , '|',
                      'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
                      'Outdent', 'Indent', '|',
                      'CreateTable', 'CreateLink', 'Image', '|', 
                      'ClearFormat', 'Print', 'SourceCode', 'FullScreen', '|', 
                      'Undo', 'Redo']
                  }">
                </ejs-richtexteditor>
            </div>
            <div class="w-full p-tiny bg-gray-300 text-right">
                <button class="btn-sm btn-primary text-xs rounded-md" 
                    @click.prevent="saveNoneDrugTreatment">
                        <i class="fa fa-save"></i> Save</button>
            </div>
            <div class="w-full overflow-auto my-2">
                <table class="table">
                    <thead class="bg-blue-500 text-white">
                        <tr>
                            <th class="p-tiny">Date</th>
                            <th class="p-tiny">Done By</th>
                            <th class="p-tiny w-56 break-words">Notes</th>
                            <th class="p-tiny">Action</th>
                        </tr>
                    </thead>
                    <tbody class="text-xs bg-gray-200">
                        <tr v-for="ndtreatment in ndtreatments" :key="ndtreatment.id">
                            <td class="p-tiny">{{ndtreatment.trxDate | dateFormat}}</td>
                            <td class="p-tiny">{{ndtreatment.userName}}</td>
                            <td class="p-tiny w-56 break-words">
                                <span v-html="ndtreatment.description"></span>
                            </td>
                            <td class="p-tiny">
                                <button @click.prevent="noneDrugTreatment = ndtreatment"
                                    class="btn-sm text-xs btn-primary rounded">
                                    <i class="fa fa-edit"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs rounded" 
        @click.prevent="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
  </template>
</tail-modal>
</template>
